export default "__VITE_ASSET__DaC2VvYf__"